@if (clearingGraph) {
    <spinner-overlay [fullscreen]="true"></spinner-overlay>
}

<div id="graph" #graphComponentRef ngClass="graph-component">
</div>

